/**
 * userService.js
 *
 * All user-related API calls in one place.
 * Functions return the resolved data, not the full axios response.
 *
 * Usage:
 *   import { userService } from 'services/api';
 *   const data = await userService.getAll();
 */

import apiClient from '../apiClient';

export const userService = {
  /** GET /users — fetch all users (bypasses pagination) */
  getAll: () =>
    apiClient.get('/users', { params: { all: 1 } }).then((res) => res.data),

  /** GET /users/options — lightweight {id, company_name, name} for dropdowns */
  getOptions: () =>
    apiClient.get('/users/options').then((res) => res.data),

  /** GET /chek-user/:id — get user balance/credits */
  getCredits: (id) =>
    apiClient.get(`/chek-user/${id}`).then((res) => res.data),

  /** GET /balance-history/:id — credit/debit history */
  getBalanceHistory: (id) =>
    apiClient.get(`/balance-history/${id}`).then((res) => res.data),

  /** GET /user/support-agents */
  getSupportAgents: (params = {}) =>
    apiClient.get('/user/support-agents', { params }).then((res) => res.data),

  /** POST /add-user — create a new sub-user */
  create: (data) =>
    apiClient.post('/add-user', data).then((res) => res.data),

  /** DELETE /delete-users/:id */
  delete: (id) =>
    apiClient.delete(`/delete-users/${id}`).then((res) => res.data),

  /** POST /send-otp */
  sendOtp: (payload) =>
    apiClient.post('/send-otp', payload).then((res) => res.data),

  /** POST /verify-otp */
  verifyOtp: (payload) =>
    apiClient.post('/verify-otp', payload).then((res) => res.data),

  /** POST /impersonate/:userId */
  impersonate: (userId, adminId) =>
    apiClient.post(`/impersonate/${userId}`, { adminId }).then((res) => res.data),

  /** POST /save-fcm-token */
  saveFcmToken: (payload) =>
    apiClient.post('/save-fcm-token', payload).then((res) => res.data),

  /** POST /remove-fcm-token */
  removeFcmToken: (payload) =>
    apiClient.post('/remove-fcm-token', payload).then((res) => res.data),

  /** GET /export-users/:id */
  exportUsers: (id) =>
    apiClient.get(`/export-users/${id}`).then((res) => res.data),

  /** GET /user/:id/storage */
  getStorage: (id) =>
    apiClient.get(`/user/${id}/storage`).then((res) => res.data),
};
